import payprosTokenTemplate from './payprosTokens.html';

/*******************************************************************************
 * @ngdoc    component
 * @name     csm.books.OurOrg.component:payprosTokens
 * @constructor
 * @param {object=} apiTokens  PayPros processor tokens.
 * @description
 * Takes input of PayPros processor tokens.
 *******************************************************************************/
export const payprosTokensComponent = {
  template: payprosTokenTemplate,
  bindings: { apiTokens: '<' }
};
